class historyBackButtonDirective {
	/**
	 *
	 * @param $state
	 */
	constructor($window) {
		"ngInject";
		this.template = `
      <small>
        <a ng-bind="'HISTORY_BACK_BUTTON' | translate"></a>
      </small>
    `;
		this.restrict = "E";
		this.$window = $window;
	}

	/**
	 *
	 * @param scope
	 * @param element
	 */
	link(scope, element) {
		element.on("click", (event) => {
			event.preventDefault();
			this.$window.history.back();
		});
	}

	static create() {
		return new historyBackButtonDirective(...arguments);
	}

}

historyBackButtonDirective.create.$inject = ["$window"];

export {historyBackButtonDirective};


// WEBPACK FOOTER //
// ./sources/utility/history-back-button/history-back-button.directive.js